import { render, staticRenderFns } from "./HeatMap.vue?vue&type=template&id=cb87f22c"
import script from "./HeatMap.vue?vue&type=script&lang=js"
export * from "./HeatMap.vue?vue&type=script&lang=js"
import style0 from "./HeatMap.vue?vue&type=style&index=0&id=cb87f22c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports